import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { ItemsToSynchronizeList } from '../../synchronization/ItemsToSynchronizeList/ItemsToSynchronizeList';
import { prepareProps } from '../../utils/propUtils';
import { Side, SidebarWithBackdrop } from '../SidebarWithBackdrop/SidebarWithBackdrop';
import styles from './SynchronizationStatusSidebar.module.css';
export type SynchronizationStatusSidebarProps = {
  opened: boolean;
  /**
   * this is called when something occured which wants to close the sidebar
   */
  onCloseSidebar: () => void;
  'data-testid'?: string;
};
export const SynchronizationStatusSidebar: FunctionComponent<SynchronizationStatusSidebarProps> = React.memo(props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    opened,
    "data-testid": testid,
    onCloseSidebar
  } = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.contentWrapper}><ItemsToSynchronizeList /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onCloseSidebar || $[4] !== opened || $[5] !== testid) {
    t2 = <SidebarWithBackdrop opened={opened} onCloseSidebar={onCloseSidebar} side={Side.Right} data-testid={testid}>{t1}</SidebarWithBackdrop>;
    $[3] = onCloseSidebar;
    $[4] = opened;
    $[5] = testid;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
});